import React from 'react';
import { Modal } from 'react-bootstrap';
import { AiOutlineClose } from 'react-icons/ai';
import { useVisualizacao } from '../../VisualizacaoContext';
import { FormActions } from '../FormActions';
import { Loading } from '../Loading';
import { DualListBox } from '../../../DualListBox';
import { CloseButton, Container, CustomModal, Footer } from './styles';
import Swal from 'sweetalert2';
import { EditableModalTitle } from '../EditableModalTitle';

const ModalVisualizacao: React.FC = () => {
  const {
    isChangeView,
    setIsChangeView,
    isOpenModal,
    setIsOpenModal,
    loadingModal,
    optionAvailable,
    setOptionAvailable,
    optionSelected,
    setOptionSelected,
    fixedColumns,
    setFixedColumns,
    handleSubmit,
    setSelectedOptionView,
    selectedOptionView,
    handleClear,
  } = useVisualizacao();

  const handleCloseModal = () => {
    if (isChangeView && selectedOptionView) {
      Swal.fire({
        title: '',
        text: 'Há alterações pendentes. Deseja salvá-las antes de continuar?',
        showCancelButton: true,
        confirmButtonText: 'Salvar Alterações',
        cancelButtonText: 'Cancelar',
        confirmButtonColor: '#0065FF',
        cancelButtonColor: '#DE350B',
        allowOutsideClick: false,
        icon: 'warning',
        didOpen: () => {
          const handleKeyDown = (event: KeyboardEvent) => {
            if (event.key === 'Enter') {
              const botao = document.querySelector<HTMLButtonElement>(
                'button.swal2-confirm.swal2-styled',
              );
              if (botao && botao.style.display !== 'none') {
                botao.click();
              }
            }
          };

          document.addEventListener('keydown', handleKeyDown);

          Swal.getPopup()?.addEventListener('close', () => {
            document.removeEventListener('keydown', handleKeyDown);
          });
        },
      }).then(async (result) => {
        if (result.isConfirmed) {
          await handleSubmit();
        } else {
          setSelectedOptionView(null);
          handleClear(true);
          setIsOpenModal(false);
        }
        setIsChangeView(false);
      });
    } else {
      setIsOpenModal(false);
      setOptionSelected([]);
    }
  };

  return (
    <>
      <CustomModal
        size="xl"
        onHide={handleCloseModal}
        show={isOpenModal}
        centered
        animation
        loadAnimation
      >
        <Modal.Header
          style={{
            paddingBottom: '0.5rem',
          }}
        >
          {!selectedOptionView && <Modal.Title>Visualização</Modal.Title>}
          {selectedOptionView && <EditableModalTitle />}
          <CloseButton onClick={handleCloseModal}>
            <AiOutlineClose size={24} />
          </CloseButton>
        </Modal.Header>
        <Modal.Body>
          {loadingModal ? (
            <Loading />
          ) : (
            <Container>
              <FormActions />
              <DualListBox
                optionAvailable={optionAvailable}
                setOptionAvailable={setOptionAvailable}
                optionSelected={optionSelected}
                setOptionSelected={(e) => {
                  setIsChangeView(true);
                  setOptionSelected(e);
                }}
              />
              <Footer>
                <span>Fixar Colunas</span>
                <input
                  type="number"
                  value={fixedColumns}
                  min={0}
                  max={Number(optionSelected.length)}
                  onChange={(event) => {
                    setFixedColumns(Number(event.target.value));
                  }}
                />
              </Footer>
            </Container>
          )}
        </Modal.Body>
      </CustomModal>
    </>
  );
};

export default ModalVisualizacao;
